// eSIM rehberi: desteklenen cihazlar (herkese açık).
import api from '../../api/client';
import { unwrap, toApiError } from '../../api/unwrap';

// GET /supported-devices → [{ type, brands: [{ title, models: [string] }] }]
export const getSupportedDevices = async () => {
  try {
    return (await api.get('/supported-devices').then(unwrap)) || [];
  } catch (error) {
    throw toApiError(error);
  }
};
